export const Config = {
	api_url:'https://zslapi.lidianhs.com/admin',
	home_url:'https://zslapi.lidianhs.com/api',
	pic_url:'https://zslapi.lidianhs.com',	
	
	// api_url:'http://www.source.com/admin',
	// home_url:'http://www.source.com/api',
	// pic_url:'http://www.source.com',
}